import { PipeTransform, Pipe } from '@angular/core';

@Pipe({
    name: 'filter',
    pure: false
})
export class FilterPipe implements PipeTransform {
    transform(value: any[], field: string, search: any) {
        if (value && value.length > 0) {
            if (value[0].hasOwnProperty(field)) {
                return value.filter(x => x[field] === search);
            }
        }
        return value;
    }
}
